import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(utc);

/**
 * Formats a date to DD/MM/YYYY format.
 * KEEPS THE ORIGINAL TIMEZONE - does NOT convert to UTC.
 * @param {string|Date|null|undefined} rawDate - Date in any format
 * @param {string} fallback - Return value if the date is invalid
 * @returns {string} Formatted date or fallback value
 */
export function formatRegistrationDate(rawDate, fallback = '---') {
  if (!rawDate || rawDate === '' || rawDate === 'null' || rawDate === 'undefined') {
    return fallback;
  }

  if (rawDate instanceof Date) {
    return dayjs(rawDate).isValid() ? dayjs(rawDate).format('DD/MM/YYYY') : fallback;
  }

  const dateStr = String(rawDate).trim();
  
  // Si ya está en formato DD/MM/YYYY o D/M/YYYY
  if (/^\d{1,2}\/\d{1,2}\/\d{2,4}$/.test(dateStr)) {
    // Probar múltiples formatos para fechas DD/MM/YYYY
    const formats = ['DD/MM/YYYY', 'D/M/YYYY', 'DD/MM/YY', 'D/M/YY'];
    let parsed;
    
    for (const format of formats) {
      parsed = dayjs(dateStr, format, true);
      if (parsed.isValid()) break;
    }
    
    return parsed && parsed.isValid() ? parsed.format('DD/MM/YYYY') : fallback;
  }

  // Intentar parsear con dayjs automático primero
  let parsed = dayjs(dateStr);
  
  // Si dayjs automático no funciona, probar formatos específicos
  if (!parsed.isValid()) {
    const formats = [
      'YYYY-MM-DD',
      'YYYY/MM/DD', 
      'DD-MM-YYYY',
      'MM/DD/YYYY'
    ];
    
    for (const format of formats) {
      parsed = dayjs(dateStr, format, true);
      if (parsed.isValid()) break;
    }
  }

  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : fallback;
}


export const buildTimeStringFromTimestamp = (timestamp) => {
  const date = new Date(timestamp)
  //NO VA CON DOBLE !== PORQUE NO LO TOMA SINO
  if (timestamp && date != 'Invalid Date')
    return `${date.toLocaleDateString()} - ${date.toTimeString().split('GMT')[0]}`
  return '---'
}

export function toLocaleUTCDateString(dateRaw) {
  const date = new Date(dateRaw)
  const timeDiff = date.getTimezoneOffset() * 60000
  const adjustedDate = new Date(date.valueOf() + timeDiff)
  return `${adjustedDate.toLocaleDateString()} - ${adjustedDate.toTimeString().split('GMT')[0]}`
}

export function convertToUTCDate(dateStr, timezone = 0) {
  const date = new Date(dateStr)
  date.setTime(date.getTime() - timezone * 60 * 60 * 1000)

  return date
}

export function formatDate(date) {
  return dayjs(date).format('YYYY-MM-DDTHH:mm:ss')
}

export function toCustomUTCDateString(timestamp, timezone = 0) {
  return dayjs.utc(timestamp).utcOffset(timezone).format('DD/MM/YYYY - HH:mm:ss (Z)')
}

export const parseNiceDateAndTimeFromTimeString = (string) => {
  if (!string) {
    return 'Invalid Input'
  }
  try {
    const [datePart, timePart] = string.split('T')
    if (!datePart || !timePart) {
      return 'Invalid Input'
    }
    const [year, month, day] = datePart.split('-').map((num) => parseInt(num, 10))
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return 'Invalid Date'
    }
    const shortYear = year % 100
    const [hours, minutes] = timePart.split(':')
    return `${month}/${day}/${shortYear}-${hours}:${minutes}`
  } catch {
    return ''
  }
}
